export { default as ResponsiveImage } from './ResponsiveImage';
